
import { RequireAuth } from "./context/auth-context"
import AdminLayout from "./layouts/admin-layout"
import Cashier from "./layouts/auth-layout"
import Userlayout from "./layouts/user-layout"
import Dashboard from "./pages/admin"
import CashierViewPaymentVouchers from "./pages/admin/cashier"
import LabMinerals from "./pages/admin/lab"
import ProcessedStockPage from "./pages/admin/lab/processed"
import GoldReport from "./pages/admin/report"
import WorkSpace from "./pages/admin/workspace"
import Sellers from "./pages/admin/workspace/seller"
import LandingPage from "./pages/user"
import ViewPurchaseOrderAndPaymentVoucher from "./pages/user/myTransactions"

const routes = [
    {
        path: "/",
        element:<Userlayout/>,
        children:[
            {
                path: "/",
                element: <LandingPage />,
            },
      
        ]
    },
    {
        path: "/admin",
        element:<RequireAuth><AdminLayout/></RequireAuth>,
        children:[
            {
                path: "/admin",
                element: <Dashboard/>,
            },
            {
                path: "/admin/workspace",
                element: <WorkSpace/>,
            },
            {
                path: "/admin/sellers",
                element: <Sellers/>,
            },
            {
                path: "/admin/lab",
                element: <LabMinerals/>,
            },
            {
                path: "/admin/processed",
                element: <ProcessedStockPage/>,
            },
            {
                path: "/admin/report",
                element: <GoldReport/>,
            },

        ]
    },
    {
        path: "/dealer",
        element:<RequireAuth><Userlayout/></RequireAuth>,
        children:[
            {
                path: "/dealer",
                element: <ProcessedStockPage/>,
            },
            {
                path: "/dealer/transactions",
                element: <ViewPurchaseOrderAndPaymentVoucher/>,
            },
        ]
    },
    {
        path: "/cashier",
        element:<RequireAuth><Cashier/></RequireAuth>,
        children:[
            {
                path: "/cashier",
                element: <CashierViewPaymentVouchers/>,
            },
           
        ]
    },


]

export default routes